import { Checkbox, Descriptions } from "antd";
import { EntityManager } from "../../components/entityManager";
import { IMetadata, enmControlType, enmPropertyType } from "../../components/entityManager/interfaces";
import { ComparisonFilter } from "../../components/infrastructure/filtering";
import { InsurerCenter } from "../insurerCenter";
import { IInsurerCenterPersonnel, IInsurerCenterPersonnelProps, IInsurerCenterPersonnelStates, enmInsurerCenterPersonnelTypes } from "./interfaces";
import { IInsurerCenterProps, enmInsurerCenterTypes } from "../insurerCenter/interfaces";
import { IZobdehUserProps, ZobdehUser, enmUserTypes } from "../userRelation/zobdehUser";

export class InsurerCenterPersonnel extends EntityManager<IInsurerCenterPersonnel, IInsurerCenterPersonnelProps, IInsurerCenterPersonnelStates>{
    static initMetadata = (): IMetadata => {
        return {
            name: "InsurerCenterPersonnel",
            title: "پرسنل اتوماسیون شعبه",
            Properties: [
                {
                    title: "شعبه",
                    dataIndex: "InsurerCenterId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 200,
                    rules: [{ required: true, message: 'لطفا نام شعبه را وارد نمایید' }],
                    lookup: {
                        lookupComponent: InsurerCenter,
                        lookupProperty: "InsurerCenter",
                        lookupDisplayFields: ["Name"]
                    }
                }, {
                    title: "نوع",
                    dataIndex: "Type",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.combobox,
                    combobox: {
                        options: [
                            { title: 'ریاست شعبه', value: enmInsurerCenterPersonnelTypes.Admin },
                            { title: 'کارشناس خسارت 1', value: enmInsurerCenterPersonnelTypes.DamageExpert1 },
                            { title: 'کارشناس خسارت 2', value: enmInsurerCenterPersonnelTypes.DamageExpert2 },
                            { title: 'کارشناس خسارت 3', value: enmInsurerCenterPersonnelTypes.DamageExpert3 },
                            { title: 'کارشناس خسارت 4', value: enmInsurerCenterPersonnelTypes.DamageExpert4 },
                        ]
                    },
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نوع پرسنلی را را تعیین نمایید' }]
                },
                {
                    title: "کاربر",
                    dataIndex: "UserId",
                    propertyType: enmPropertyType.number,
                    controlType: enmControlType.lookup,
                    filterable: true,
                    width: 300,
                    rules: [{ required: true, message: 'کاربر اجباری است' }],
                    lookup: {
                        lookupComponent: ZobdehUser,
                        lookupProperty: "User",
                        lookupDisplayFields: ["UserName", "FullName"]
                    }
                },
                {
                    title: "نام کاربری اتوماسیون",
                    dataIndex: "OAUserName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150
                },
                {
                    title: "تایید اتوماسیون؟",
                    dataIndex: "OAUserId",
                    controlType: enmControlType.template,
                    filterable: false,
                    showControl: false,
                    renderColumn: (_, record) => {
                        return <Checkbox checked={record && !!record['OAUserId']} />
                    },
                    width: 100
                }
            ]
        };
    }

    onInitializing() {
        this.searchable = true;
        this.searchArea = {
            columnsPerRow: 2
        };

        this.onEntityAdded = (entity) => {
            let params = this.props.params && this.props.params();
            if (params) {
                if (params.insurerCenter?.Id) {
                    entity.InsurerCenterId = params.insurerCenter.Id;
                    entity.InsurerCenter = params.insurerCenter;
                    entity.ModifiedProperties.push("InsurerCenterId");
                }
            }
            return true;
        };

        this.originalFilter = () => {
            let params = this.props.params && this.props.params();
            if (params?.insurerCenter !== undefined)
                return ComparisonFilter.Equal<IInsurerCenterPersonnel>(r => r.InsurerCenterId, params.insurerCenter.Id);
        };

        this.extraHeaderNodes = () => {
            let params = this.props.params && this.props.params();
            let insurerCenter = params && params.insurerCenter;
            return (
                <Descriptions className="header-page" key="">
                    <Descriptions.Item label="نام شعبه">{insurerCenter?.Name}</Descriptions.Item>
                </Descriptions>
            );
        };

        this.preparelookupProps = (propName, lookupProps) => {
          
            if (propName === "InsurerCenterId")
                (lookupProps as IInsurerCenterProps).params = () => {
                    let currentParams = this.props.params && this.props.params();
                    let insurer = currentParams?.insurerCenter?.Insurer;
                    return { insurer, type: enmInsurerCenterTypes.Branch };
                };

            if (propName === "UserId") {
                const zobdehUserProps = lookupProps as IZobdehUserProps;
                zobdehUserProps.userType = enmUserTypes.Spc;
                let currentParams = this.props.params && this.props.params();
                zobdehUserProps.relationSourceId = currentParams?.insurerCenter?.Id;
            }

            return lookupProps;
        }
    }
}